import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VideoApi } from '../video.api';
import { ApiHttpResponse, VideoSection } from '@kinomap-dev/ng-ui-lib';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
  useClass: VideoApi,
})
export abstract class IVideoApi {
  abstract getVideos(
    page: number,
    limit: number,
    userId?: number,
    params?: HttpParams
  ): Observable<ApiHttpResponse<VideoSection[]>>;
}
